// Mail→Vorgang SP3 (C3): Beim Vorgang aus einer Mail werden Betreff und
// Inhalt der E-Mail NIEMALS automatisch in den Vorgang übernommen (bisheriges
// Verhalten abgeschafft) — vorbelegt wird NUR der erkannte/gewählte Kontakt als
// Zuweisung. `initialSubject`/`initialNote` bleiben anderen Aufrufern
// (Schadenmappe, Austausch-Termine, Kontakt-Notiz …) vorbehalten; der
// Mail-Snapshot für den MailLink (Schriftwechsel-Anzeige) ist davon
// unberührt (Leitplanke L3).
//
// Cluster VORGANG (E1/E5) ergänzt zwei Dinge, ohne C3 aufzuweichen:
//  - `einschrittig: true` — aus der Mail entfällt Schritt 1 (der Kontakt steht
//    ja fest). Ohne Kontakt greift der Parameter im Flow selbst nicht (E8).
//  - `mailBetreff` — der Betreff der Quell-Mail reist als ANGEBOT für den
//    Stift-Button mit und landet erst auf Klick im Feld. Vorbelegt wird er
//    weiterhin nicht.
//  - Runde 3 (P4): Die führende Kunden-Klammer („(Acme GmbH / ") wird HIER
//    entfernt und nicht bei den Aufrufern. Sie ist die EINE Naht aller drei
//    Mail-Einstiege (Lesefenster, Lesepanel, Rechtsklick in der Liste) — lag
//    der Schnitt beim Aufrufer, bot derselbe Knopf je nach Weg einen anderen
//    Betreff an. Genau einmal anwenden: bei verschachtelten Klammern ist der
//    Schnitt NICHT idempotent („(A / (B / C" → „(B / C" → „C").
import { betreffOhneKundenKlammer } from "./betreffAusfuellen";
import type { OpenVorgangCreateFlowParams } from "../vorgang/create/VorgangCreateFlowWindow";

export type MailVorgangPrefill = Pick<
    OpenVorgangCreateFlowParams,
    "initialContactId" | "initialContactName" | "einschrittig" | "mailBetreff"
>;

/** Erstell-Flow-Vorbelegung aus einer Mail: nur der Kontakt, nie Betreff/Inhalt. */
export function mailVorgangPrefill(
    // `displayName` optional: die Erkennungs-Chips (Vertrag/Risiko) liefern nur
    // eine `contactId` ohne Namen — dann bleibt `initialContactName` null, was
    // der Erstell-Flow bereits abdeckt.
    matched: { id: number; displayName?: string } | null | undefined,
    mailBetreff?: string | null,
): MailVorgangPrefill {
    return {
        initialContactId: matched?.id ?? null,
        initialContactName: matched?.displayName ?? null,
        // Für ALLE Mail-Aufrufer fest gesetzt; der Flow ignoriert es ohne Kontakt.
        einschrittig: true,
        mailBetreff: angebotenerBetreff(mailBetreff),
    };
}

/**
 * Der Betreff, den der Stift-Knopf anbietet: ohne die führende Kunden-Klammer,
 * und leer heißt „kein Angebot" (der Knopf erscheint dann gar nicht).
 */
function angebotenerBetreff(roh: string | null | undefined): string | null {
    if (!roh?.trim()) return null;
    const ohneKlammer = betreffOhneKundenKlammer(roh).trim();
    return ohneKlammer ? ohneKlammer : null;
}
